import { Component, ViewEncapsulation, Input } from '@angular/core';
import { ResortDetail, ResortInventory } from '../../models/presentation.model';
import { ResortInformation } from '../resort-information/resort-information.model';
import { Core} from '../../shared/core/ovs.core';


@Component({
    selector: 'checkout-header',
    templateUrl:'./checkout-header.component.html',
    styleUrls: ['./checkout-header.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class CheckOutHeaderComponent{
    @Input() info: ResortInformation;
    @Input() resort: ResortDetail;
    @Input() inventory: ResortInventory;
    @Input() intervalId: number;
    private _core: Core;

    constructor(core: Core) {
        this._core = core;
    }
    public hideResortCreditMessage(): boolean {
        return this._core.currentConfiguration.HideResortCreditMessage;
    }

}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/check-out/checkout-header/checkout-header.component.ts